var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDowngray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91307 11.2084C7.69934 11.2084 7.48564 11.1297 7.32269 10.9725L2.195 6.02497C1.86881 5.71024 1.86881 5.19996 2.195 4.88536C2.52106 4.57076 3.04981 4.57076 3.37602 4.88536L7.91307 9.26325L12.4501 4.88552C12.7763 4.57092 13.305 4.57092 13.6311 4.88552C13.9574 5.20012 13.9574 5.71039 13.6311 6.02512L8.50345 10.9727C8.34043 11.1299 8.12672 11.2084 7.91307 11.2084Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDowngray);
export default __webpack_public_path__ + "static/media/arrow-down.gray.e2d9feb003996f0b30026e4639d85ebb.svg";
export { ForwardRef as ReactComponent };